// extracted by mini-css-extract-plugin
export default {"fullWidthCTA":"FullWidthCTA_fullWidthCTA__ReoQe"};